<ng-content *ngIf="isV1Enabled$ | async">
    <app-login></app-login>
</ng-content>
<ng-content *ngIf="isV2Enabled$ | async">
    <app-login-v2></app-login-v2>
</ng-content>
